import { camelizeKeys } from 'humps';
import { isEmpty } from 'lodash-es';
import { RejectFunction, ResolveFunction, Response } from './types';

const isErrorInResponse = (response: Response) =>
  (response.error !== undefined && response.error !== 'no') ||
  !isEmpty(response.errorCode) ||
  response.status === 'error' ||
  response.status === 'fail' ||
  (response.status &&
    Number(response.status) >= 400 &&
    Number(response.status) < 600);

// We got a new standart for responses: https://wiki.betinvest.work/display/PLAT/API+standard#APIstandard-APIresponse
const isStandartError = ({ status }: Response) => status === 'error';

export const defaultResponseHandler = <T extends Response>(
  response: T,
  resolve: ResolveFunction,
  reject: RejectFunction
) =>
  !isErrorInResponse(response)
    ? resolve(response)
    : reject(camelizeKeys(response));

export const standardResponseHandler = <T extends Response>(
  response: T,
  resolve: ResolveFunction,
  reject: RejectFunction
) =>
  isStandartError(response)
    ? reject(camelizeKeys(response))
    : resolve(response);

export const ihubResponseHandler = <T extends Response>(
  response: T,
  resolve: ResolveFunction,
  reject: RejectFunction
) =>
  !isErrorInResponse(response)
    ? resolve(response)
    : reject(camelizeKeys(response));

// TODO this is hardly exactly "bettorrent" format, but we get it with new API. I think this should not exist in the first place.
export const bettorrentResponseHandler = <T extends Response>(
  response: T,
  resolve: ResolveFunction,
  reject: RejectFunction
) =>
  !isErrorInResponse(response)
    ? resolve(response)
    : reject(camelizeKeys(response));
